import { isRuntimeFlagEnabled } from '~/utils/runtimeFlag';
import { buildCalltouchLoaderScript, CALLTOUCH_MOD_ID_PATTERN } from '~/utils/calltouch';

export default defineNuxtPlugin(() => {
  const { isCalltouchEnabled, calltouchModId } = useRuntimeConfig().public;
  const modId = String(calltouchModId || '');

  if (!isRuntimeFlagEnabled(isCalltouchEnabled) || !CALLTOUCH_MOD_ID_PATTERN.test(modId)) return;

  useHead({
    script: [
      {
        key: 'calltouch-loader',
        'data-calltouch-loader': '',
        innerHTML: buildCalltouchLoaderScript(modId),
        tagPosition: 'head',
      },
    ],
  });

  if (import.meta.client) {
    const { initializeCalltouchSession } = useCalltouch();
    void initializeCalltouchSession();
  }
});
